export default function clsx(objCls = {}) {
  return Object.keys(objCls)
    .filter(cls => objCls[cls])
    .join(' ')
}
